import React from "react";

function CircleIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="prefix__feather prefix__feather-circle"
      {...props}
    >
      <circle cx={12} cy={12} r={10} />
    </svg>
  );
}

export default CircleIcon;
